import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { goBack } from 'react-router-redux'

import Payment from './Payment'
import * as fromEntities from '@src/redux/modules/entities'
import * as fromService from '@src/redux/modules/service'
import { display as displayError } from '@src/redux/modules/error'
import {
  createValidator,
  required,
  isCreditCardNumber,
  isCvcNumber,
  hasNotExpired
} from 'utils/validations'

let PaymentContainer = reduxForm({
  form: 'payment',
  validate: createValidator({
    number: [required, isCreditCardNumber],
    exp_month: [required, hasNotExpired],
    exp_year: [required, hasNotExpired],
    cvc: [required, isCvcNumber],
    name: required
  })
})(Payment)

const mapStateToProps = (state, ownProps) => {
  const creatingService = fromService.isCreating(state)
  const aliadas = fromEntities.getAliadas(state)
  const aliadaId = ownProps.params.aliadaId

  return {
    creatingService,
    aliada: aliadas[aliadaId],
    service: state.service
  }
}

const mapDispatchToProps = {
  updateService: fromService.updateNewService,
  createService: fromService.create,
  displayError,
  goBack
}

PaymentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentContainer)

export default PaymentContainer



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/Payment/PaymentContainer.js